import {
  recognitionDefaultValuesService,
  RecognitionDefaultValuesResponse,
  useToast,
} from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

const useFetchRecognitionDefaultValues = (enabled = true) => {
  const toast = useToast();

  return useQuery<RecognitionDefaultValuesResponse, Error>({
    queryKey: ['fetchRecognitionDefaultValues'],
    queryFn: () => recognitionDefaultValuesService.fetchRecognitionDefaultValues(),
    enabled,
    onError: () => {
      toast({
        position: 'top-right',
        status: 'error',
        title: 'Something went wrong',
        description: 'Failed to load default recognition values. Please try again.',
      });
    },
  });
};

export default useFetchRecognitionDefaultValues;
